export default __webpack_public_path__ + "static/media/syft.ee6b1e33.png";